import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { PAGE_SLUG } from 'Modules'
import { FiltersModel } from 'Types/filters'

export type FiltersState = {
	filters: Map<PAGE_SLUG, FiltersModel | null>
}

const initialState: FiltersState = {
	filters: new Map(),
}

export namespace FiltersNS {
	export type ClearFilters = PayloadAction<PAGE_SLUG>
	export type SetFilters = PayloadAction<{ key: PAGE_SLUG; fields: FiltersModel }>
}

export const filtersSlice = createSlice({
	name: 'filtersState',
	initialState,
	reducers: {
		clearFilters: (state, action: FiltersNS.ClearFilters) => {
			state.filters.delete(action.payload)
		},
		setFilters: (state, action: FiltersNS.SetFilters) => {
			const { key, fields } = action.payload
			state.filters.set(key, fields)
		},
	},
})
